export default __webpack_public_path__ + "static/media/element_23.3b6f09bd.jpg";